import { Box, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { FiFileText } from "react-icons/fi";
import type { Entrega } from "../utils/agruparEntregas";

interface IProps {
  entrega: Entrega;
  children?: ReactNode;
}

// Faixa com as notas fiscais da entrega. Mesmo visual no card da listagem e na tela "Concluir Entrega".
const NotasFiscaisDaEntrega = ({ entrega, children }: IProps) => {
  const notaUnica = entrega.notas.length === 1;

  return (
    <Box mt={2} p={2} bg="gray.50" borderRadius={5} fontSize="0.9rem" width="full">
      <Flex alignItems="center" gap={2} wrap="wrap">
        <Text fontWeight="bold" color="blue.700">{notaUnica ? 'Nota Fiscal:' : 'Notas Fiscais desta entrega:'}</Text>
        {entrega.notas_numeros.map((numero) => (
          <Flex key={numero} alignItems="center" gap={1}>
            <FiFileText color="#2b6cb0" />
            <Text>{numero}</Text>
          </Flex>
        ))}
      </Flex>
      {children}
    </Box>
  )
}

export default NotasFiscaisDaEntrega;
